import React, { useRef, useState } from "react";
import * as _ from "lodash";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import { Button, Container, Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import XLSX from "xlsx";
import { Header } from "../Header";
import adminModulestyle from "../style";
import style from "./style";
import { SnackbarAlert } from "../../../UI/Snackbar";
import { UIOutlineButton } from "../../../UI/Buttons";
import { CircularProgress } from "../../../UI/Progress";
import { Axios } from "../../../api/service/Axios";

// Create styles
const adminModuleUseStyles = makeStyles(() => createStyles(adminModulestyle()));
const useStyles = makeStyles(() => createStyles(style()));

// QueryGenerator Component
export const QueryGenerator = (): React.JSX.Element => {
  const bundle = useSelector((state: any) => state.initial.bundle);
  const [loading, setLoading] = useState(false);
  const [fileData, setFileData] = useState(null);
  const fileInputRef: any = useRef(null);
  const fileNameRef: any = useRef(null);
  const adminModuleClasses = adminModuleUseStyles();
  const classes = useStyles();

  const [snackbar, setSnackbar] = useState({
    message: "",
    open: false,
    variant: "success",
  });

  const handleCloseAlert = (): void => {
    return setSnackbar({
      ...snackbar,
      open: false,
    });
  };

  const fileReader = (file: any): Promise<any> => {
    return new Promise((resolve: any, reject: any) => {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        resolve(event.target.result);
      };
      reader.onerror = () => {
        reject(new Error("Unable to read the selected file"));
      };
      reader.readAsArrayBuffer(file);
    });
  };

  const onFileInputChange = async (file: any): Promise<void> => {
    const data = await fileReader(file);
    const Workbook = XLSX.read(data, { type: "array" });
    const Sheets = Workbook.SheetNames;
    const SheetData: any = {};
    for (let i = 0; i < Sheets.length; i++) {//NOSONAR
      SheetData[Sheets[i]] = XLSX.utils.sheet_to_json( //NOSONAR
        Workbook.Sheets[Sheets[i]]//NOSONAR
      );
    }
    setFileData(SheetData);
  };

  const onSubmit = (): void => {
    setLoading(true);

    Axios.post(
      "https://automated-form-creator-service-dot-campaignautomations-dev.nw.r.appspot.com/sql",
      fileData
    )
      .then((response: any) => {
        const blob = new Blob([response.data], {
          type: "application/sql",
        });
        const link: HTMLAnchorElement = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "query.sql";
        link.click();
        setSnackbar({
          message: bundle.TOOL_QUERY_BUILDER_SUCCESS,
          open: true,
          variant: "success",
        });
        setLoading(false);
      })
      .catch(() => {
        setSnackbar({
          message: bundle.TOOL_QUERY_BUILDER_ERROR,
          open: true,
          variant: "error",
        });
        setLoading(false);
      });
  };

  return (
    <>
      <Helmet>
        <title>{bundle.MENU_QUERY_BUILDER_TITLE}</title>
      </Helmet>
      <Header
        name={bundle.MENU_QUERY_BUILDER_TITLE}
        data-testid="QueryBuilderTest"
      />
      <Container maxWidth="lg">
        <Grid container className={adminModuleClasses.toolContentWrapper}>
          <Grid container item className={adminModuleClasses.infoWrapper}>
            {loading && <CircularProgress />}
            <div className={adminModuleClasses.toolContent}>
              <Grid
                container
                alignItems="center"
                item
                lg={9}
                md={9}
                sm={12}
                xs={12}
              >
                <input
                  type="file"
                  onChange={(fileEvent: any) => {
                    if (_.isEmpty(fileEvent.target.files)) {
                      return;
                    }
                    onFileInputChange(fileEvent.target.files[0]);
                    fileNameRef.current.innerText =
                      fileEvent.target.files[0].name;
                  }}
                  onClick={() => (fileInputRef.current.value = null)}
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  accept=".xlsx,.xls"
                />
                <UIOutlineButton
                  isOutline={true}
                  onClick={(): void => {
                    fileInputRef.current.click();
                  }}
                  cssStyle={{
                    textTransform: "none",
                    fontWeight: 600,
                  }}
                  btnText="Select File"
                />
                <span ref={fileNameRef} className={classes.fileName}></span>
              </Grid>
              <div className={classes.uploadFileTemplate}>
                <a
                  target="_blank"
                  rel="noreferrer"
                  className={classes.templateLink}
                  href={"https://storage.googleapis.com/automations_portal_read_only/Toolform_Querybuilder/tool_configuraton.xlsx"}
                >
                  {bundle.DOWNLOAD_TEMPLATE_LINK_TITLE}
                </a>
              </div>
              <Button
                variant="contained"
                color="primary"
                onClick={onSubmit}
                className={classes.btnSubmit}
              >
                Submit
              </Button>
            </div>
          </Grid>
        </Grid>
        <SnackbarAlert
          open={snackbar.open}
          message={snackbar.message}
          variant={snackbar.variant}
          onOpenCloseAlert={handleCloseAlert}
        />
      </Container>
    </>
  );
};
